import { getMCPMonitorDistribution } from "@/api/endpoints/searches";
import { SOURCE_CODE_TO_LABEL } from "@/constants";
import { cn } from "@/lib/utils";
import { SearchFilterV4WithDates } from "@/types/SearchFilter";
import {
  Widget,
  WidgetHeader,
  WidgetProps,
  WidgetStat,
  WidgetTitle,
} from "@components/ui/widget";
import {
  getMCPMonitorFiltersFromSearchFilterV4,
  getTopChannelType,
} from "@components/widgets/utils";
import { i18n } from "@lingui/core";
import { Trans } from "@lingui/react/macro";
import { useQuery } from "@tanstack/react-query";

export default function ReachDriverWidget({
  searchUuid,
  className,
  filters,
  ...rest
}: WidgetProps & {
  searchUuid: Uuid;
  filters: SearchFilterV4WithDates;
}) {
  // Server state
  const { data: topChannelTypesData, isLoading } = useQuery({
    queryKey: [
      searchUuid,
      "insights-reach",
      "channel-type-distribution",
      filters,
    ],
    queryFn: async () => {
      return getMCPMonitorDistribution(searchUuid, {
        ...getMCPMonitorFiltersFromSearchFilterV4(filters),
        metric: "reach",
      });
    },
  });

  // Helpers
  const topChannelType = topChannelTypesData?.ok
    ? getTopChannelType(topChannelTypesData.data.shares)
    : undefined;

  return (
    <Widget className={cn("h-23.5 gap-0.5", className)} {...rest}>
      <WidgetHeader isLoading={isLoading}>
        <WidgetTitle>
          <Trans>Största räckviddsdrivaren</Trans>
        </WidgetTitle>
        {topChannelType ? (
          <WidgetStat>
            {i18n._(SOURCE_CODE_TO_LABEL[topChannelType])}
          </WidgetStat>
        ) : null}
      </WidgetHeader>
    </Widget>
  );
}
